// Bộ icon FontAwesome mà MOBILE APP hỗ trợ cho Utility Blocks.
// PHẢI khớp ICON_MAP ở mobile/src/modules/utility/components/utility-blocks-section.tsx
// → preview trong admin = icon thật app render. Icon không nằm trong map này khi
// lên app sẽ fallback về faLink, nên admin chỉ cho chọn trong danh sách này.
import {
    faBolt, faGift, faStar, faFire, faTag, faTags, faShoppingCart, faShoppingBag,
    faHeart, faTrophy, faTicketAlt, faLink, faVideo, faGamepad, faGlobe, faStore,
    faPercent, faCoins, faBell, faGem, faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faTiktok } from "@fortawesome/free-brands-svg-icons";

/** Map tên (string admin nhập, vd "faBolt") → định nghĩa icon. */
export const UTILITY_ICON_MAP = {
    faBolt, faGift, faStar, faFire, faTag, faTags, faShoppingCart, faShoppingBag,
    faHeart, faTrophy, faTicketAlt, faLink, faVideo, faGamepad, faGlobe, faStore,
    faPercent, faCoins, faBell, faGem, faWandMagicSparkles, faFacebook, faTiktok,
};

/** Danh sách tên icon hỗ trợ (để render bộ chọn nhanh). */
export const UTILITY_ICON_NAMES = Object.keys(UTILITY_ICON_MAP);

/** Lấy icon theo tên; trả undefined nếu không hỗ trợ (app sẽ fallback faLink). */
export function getUtilityIcon(name) {
    return name ? UTILITY_ICON_MAP[name] : undefined;
}
